module.exports = __webpack_public_path__ + "static/image-03-a@2x-5cc8dcbeb413b70bc02e37149fab9bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/laboratoria/image-03-a@2x.jpg
// module id = 388
// module chunks = 3627797113349 20562973939449 33019919093843